/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Pop_Up_ContentInputs */

const en_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit one purchase. Get Luminie, 30 Time Crystals, and 600 coins at a special price. Available for 7 days.`)
};

const ar_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشراء متاح مرة واحدة فقط! احصل على Luminie، بلورة الزمن ×30، و600 عملة بسعر خاص. العرض متاح لمدة 7 أيام.`)
};

const de_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur einmal erhältlich! Sichere dir Luminie, 30 Time Crystals und 600 Münzen zum Sonderpreis. Das Angebot gilt 7 Tage lang.`)
};

const es_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Solo se puede comprar una vez! Consigue Luminie, 30 cristales de tiempo y 600 monedas a un precio especial. Oferta válida durante 7 días.`)
};

const fr_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un seul achat possible ! Obtenez Luminie, 30 Cristaux de temps et 600 Pièces à prix spécial. Offre valable pendant 7 jours.`)
};

const it_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquistabile una sola volta! Ottieni Luminie, 30 Cristalli del Tempo e 600 Monete a un prezzo speciale. Offerta valida per 7 giorni.`)
};

const ja_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入は1回限り！Luminie、時の結晶30個、コイン600枚を特別価格で購入できます。オファーは7日間限定です。`)
};

const ko_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단 한 번만 구매할 수 있어요! Luminie, 타임 크리스탈 30개, 코인 600개를 특별한 가격으로 만나보세요. 혜택은 7일 동안 제공돼요.`)
};

const pt_br_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível para uma única compra! Adquira Luminie, 30 Cristais do Tempo e 600 Moedas por um preço especial. Oferta válida por 7 dias.`)
};

const ru_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можно купить только один раз! Получите Luminie, Кристальное Время ×30 и 600 монет по специальной цене. Предложение действует 7 дней.`)
};

const th_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อได้เพียงครั้งเดียว! รับ Luminie คริสตัลแห่งกาลเวลา 30 ชิ้น และเหรียญ 600 เหรียญในราคาพิเศษ ข้อเสนอนี้มีอายุ 7 วัน`)
};

const tr_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca bir kez satın alınabilir! Luminie, Zaman Kristalleri ×30 ve 600 Jeton içeren bu paketi özel fiyata al. Teklif 7 gün boyunca geçerlidir.`)
};

const zh_cn_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限购一次！以优惠价购买 Luminie、30 颗时光宝石与 600 枚金币。优惠限时七天。`)
};

const zh_tw_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限購一次！以優惠價入手 Luminie、30 顆時光寶石與 600 枚金幣。優惠限時七天。`)
};

/**
* | output |
* | --- |
* | "Limit one purchase. Get Luminie, 30 Time Crystals, and 600 coins at a special price. Available for 7 days." |
*
* @param {Starter_Pack_Pop_Up_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_pop_up_content = /** @type {((inputs?: Starter_Pack_Pop_Up_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Pop_Up_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_pop_up_content(inputs)
	if (locale === "ar") return ar_starter_pack_pop_up_content(inputs)
	if (locale === "de") return de_starter_pack_pop_up_content(inputs)
	if (locale === "es") return es_starter_pack_pop_up_content(inputs)
	if (locale === "fr") return fr_starter_pack_pop_up_content(inputs)
	if (locale === "it") return it_starter_pack_pop_up_content(inputs)
	if (locale === "ja") return ja_starter_pack_pop_up_content(inputs)
	if (locale === "ko") return ko_starter_pack_pop_up_content(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_pop_up_content(inputs)
	if (locale === "ru") return ru_starter_pack_pop_up_content(inputs)
	if (locale === "th") return th_starter_pack_pop_up_content(inputs)
	if (locale === "tr") return tr_starter_pack_pop_up_content(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_pop_up_content(inputs)
	return zh_tw_starter_pack_pop_up_content(inputs)
});